import { Typography } from "../../../core/components/molecules/Typography";
import { Button } from "../../../core/components/atoms/Button";
import { useNavigate } from "react-router-dom";

const MGMTermsPage = () => {
  const navigate = useNavigate();

  const terms = [
    {
      title: 'EMPRESA PROMOTORA',
      content: [
        {
          text: 'A campanha "Indique o Aprova Total e ganhe ainda mais chances de ser aprovado!" é promovida pela APROVA TOTAL EDUCAÇÃO SA, pessoa jurídica de direito privado, inscrita no Cadastro Nacional da Pessoa Jurídica (CNPJ/ME) sob o nº 18.311.735/0001-00, com sede na Rua Nirberto Haase, 100, bairro Santa Mônica, cidade de Florianópolis/SC, CEP 88.035-215, neste ato representada por seu administrador legal PAULO ROBERTO JUBILUT, conforme seu contrato social, doravante denominada "Aprova Total".'
        }
      ]
    },
    {
      title: 'OBJETO E OBJETIVO DA CAMPANHA',
      content: [
        {
          text: 'A presente campanha promocional, denominada "Indique o Aprova Total e ganhe ainda mais chances de ser aprovado!", tem como objetivo incentivar a indicação de novos usuários para a plataforma Aprova Total, oferecendo benefícios ao aluno indicador (alunos com planos ativos) e ao amigo indicado, conforme as condições previstas neste Regulamento.'
        },
        {
          text: 'A participação é voluntária e implica aceitação integral deste Regulamento.'
        }
      ]
    },
    {
      title: 'PERÍODO DE VIGÊNCIA',
      content: [
        {
          text: 'A campanha terá início às 17h de 05/02/2026, ambos horários de Brasília.'
        },
        {
          text: 'A Aprova Total poderá alterar, suspender ou encerrar a campanha a qualquer momento, mediante comunicação prévia aos participantes pelos seus canais oficiais de comunicação (e-mail, redes sociais, site da Aprova Total), sem que isso gere direito a indenização ou compensação aos participantes.'
        }
      ]
    },
    {
      title: 'PÚBLICO-ALVO',
      content: [
        {
          text: 'Poderão participar na figura de aluno indicador os alunos da Aprova Total com planos ativos, maiores de 18 anos, residentes no Brasil, desde que não possuam acesso ativo ao Aprova Live até a data de publicação deste Regulamento.'
        },
        {
          text: 'Alunos que já possuem assinatura ativa do Aprova Live não terão direito a qualquer recompensa nesta campanha, inclusive reembolso ou compensação de qualquer natureza.'
        }
      ]
    },
    {
      title: 'MECÂNICA DA CAMPANHA E BENEFÍCIOS',
      content: [
        {
          text: 'Benefício para o Aluno Indicador',
          subItems: [
            {
              text: 'Ao indicar 1 (um) amigo que efetive a compra de qualquer plano da plataforma Aprova Total dentro do período de vigência da campanha, o aluno indicador terá direito a acesso ao Aprova Live até o dia 31/12/2026.'
            },
            {
              text: 'O benefício será liberado após a confirmação do pagamento da compra realizada pelo amigo indicado e validação da indicação pelos sistemas da Aprova Total.'
            },
            {
              text: 'O acesso ao Aprova Live concedido como recompensa: é pessoal e intransferível; não pode ser convertido em dinheiro; não gera direito a reembolso ou extensão de prazo após 31/12/2026.'
            }
          ]
        },
        {
          text: 'Benefício para o Amigo Indicado',
          subItems: [
            {
              text: 'Todo amigo indicado que efetivar a compra por meio do link ou código de indicação válido terá direito a 10% (dez por cento) de desconto no valor da contratação da plataforma Aprova Total.'
            },
            {
              text: 'O desconto é aplicado exclusivamente no momento da contratação realizada por meio do link ou código de indicação válido.'
            }
          ]
        }
      ]
    },
    {
      title: 'CONDIÇÕES GERAIS DA CAMPANHA',
      content: [
        {
          text: 'Participação: A participação nesta campanha é voluntária e gratuita (salvo a aquisição do produto e/ou serviço da Aprova Total pelos indicados) e implica na aceitação total, irrestrita e irrevogável de todas as cláusulas e condições deste regulamento.',
        },
        {
          text: 'Indicações Válidas e Rastreamento:',
          subItems: [
            {
              text: 'Somente serão consideradas válidas as indicações realizadas por meio de link ou código individual fornecido pela Aprova Total.'
            },
            {
              text: 'Indicações não rastreadas pelo sistema não serão computadas.'
            },
            {
              text: 'Não serão consideradas compras realizadas antes da utilização do link/código de indicação.'
            },
            {
              text: 'A Aprova Total se reserva o direito de verificar a validade das indicações e comprovantes de pagamento, podendo desqualificar indicações que apresentem indícios de fraude ou má-fé.'
            }
          ]
        },
        {
          text: 'A liberação do Aprova Live no acesso do aluno indicador ocorrerá em até 01 (um) dia útil após a validação das indicações.',
        },
        {
          text: 'Qualquer tentativa de fraude, manipulação de resultados, utilização de robôs, scripts ou qualquer outra forma de alteração indevida no sistema de participação ou indicações, bem como qualquer ato de má-fé, resultará na desclassificação imediata do participante da campanha, sem prejuízo das medidas legais cabíveis e revogação dos produtos e serviços já adquiridos.',
        },
        {
          text: 'Para dúvidas, informações adicionais, ou para solicitar o estorno (caso aplicável), os participantes poderão entrar em contato com a Aprova Total através dos seguintes canais, durante o horário comercial de 09h às 18h (horário de Brasília), de segunda a sexta-feira, exceto feriados:',
          subItems: [
            {
              text: 'E-mail: contato@aprovatotal.com.br'
            },
            {
              text: 'Telefone: +55 48 8828-4533'
            },
            {
              text: 'Chat online disponível no site oficial, disponível na seção Fale Conosco, mediante login na Plataforma Aprova Total.'
            }
          ]
        },
        {
          text: 'Dados Pessoais: Ao participar da campanha, os participantes concordam com a coleta e o tratamento de seus dados pessoais pela Aprova Total, estritamente para os fins de gestão da campanha, comunicação de resultados e entrega de benefícios, em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 - LGPD) e a Política de Privacidade da Aprova Total, disponível em https://aprovatotal.com.br/politica-de-privacidade.'
        }
      ]
    },
    {
      title: 'CRITÉRIOS DE DESCLASSIFICAÇÃO',
      content: [
        {
          text: 'Serão desclassificadas desta campanha, a qualquer momento, a participação com fraude comprovada; efetuada através da obtenção de benefício/vantagem de forma ilícita; que pertencerem a pessoas impedidas de participar; que não apresentarem dados suficientes à identificação do participante e/ou do comprador ou que não cumprir quaisquer das condições deste Regulamento, incluindo, mas não se limitando, aos seguintes casos, a participação: (i) com mais de um CPF; (ii) em que não haja a efetiva confirmação da comprovação da condição de participação; e (iii) que utilize mecanismos que criem condições irregulares e/ou desleais ou que atentem contra os objetivos e condições de participação desta campanha.',
        },
        {
          text: 'O participante será excluído automaticamente da campanha em caso de desclassificação e/ou fraude e/ou não atendimento de quaisquer dos requisitos válidos de participação, como por exemplo, mas não se limitando a, não ter o participante efetuado, de fato, a compra de produtos para participação da campanha.',
        },
        {
          text: 'Não poderão participar da campanha, empregados, bem como seus parentes de 1º e 2º graus, em linha reta, ascendente ou descendente ou colateral, da Aprova Total.',
          subItems: [
            {
              text: 'As pessoas mencionadas acima, quando identificadas e que de alguma maneira manipularam ou fraudaram o regulamento para participar da campanha não terão direito à premiação.'
            }
          ]
        },
        {
          text: 'Se porventura, a Aprova Total receber uma denúncia posterior à apuração e anterior à entrega do prêmio, indicando que qualquer ganhador se enquadra em uma das categorias acima e não poderia ter participado da campanha, após comprovação da denúncia, este perderá imediatamente o direito ao prêmio.',
        }
      ]
    },
    {
      title: 'DISPOSIÇÕES GERAIS',
      content: [
        {
          text: 'O benefício concedido não poderá ser trocado por dinheiro, produtos ou outros serviços.',
        },
        {
          text: 'Quaisquer situações não previstas neste regulamento, bem como dúvidas ou controvérsias decorrentes da interpretação ou aplicação deste, serão decididas exclusivamente pela Aprova Total, observando a legislação aplicável e a boa-fé.',
        },
        {
          text: 'A Aprova Total não se responsabiliza por problemas técnicos, falhas de conexão, erros de transmissão de dados ou quaisquer outros fatores que impossibilitem ou dificultem a participação na campanha ou o rastreamento das indicações, desde que não sejam comprovadamente causados por falha da Aprova Total.',
        },
        {
          text: 'A efetivação da participação na campanha, de qualquer forma, constitui aceitação tácita e integral de todos os termos e condições deste regulamento.',
        },
        {
          text: 'Fica eleito o foro da Comarca de Florianópolis, Estado de Santa Catarina, com exclusão de qualquer outro, por mais privilegiado que seja, para dirimir quaisquer dúvidas ou controvérsias oriundas do presente regulamento e da campanha.',
        }
      ]
    }
  ];

  return (
    <div className="w-full h-fit py-10 flex justify-center items-center">
      <div className="w-[95%] md:w-[80%] flex flex-col gap-8 bg-mono-color-white rounded-md shadow-sm p-8">
        <Typography type="title" size="h1" className="text-center"> Termos e Condições </Typography>
        <div className="flex flex-col gap-6">
          <Typography weight="bold" className="uppercase">
            Regulamento da campanha &ldquo;Indique o Aprova Total e ganhe ainda mais chances de ser aprovado!&rdquo;
          </Typography>
          <Typography >
            Este regulamento é um anexo aos Termos de Uso da Aprova Total, disponíveis em <a href="https://aprovatotal.com.br/termos-de-uso/" target="_blank" rel="noopener noreferrer">https://aprovatotal.com.br/termos-de-uso/</a>.
          </Typography>
          {terms.map((term, indexT) => (
            <div key={indexT} className="flex flex-col gap-[10px] mb-6">
              <Typography weight="bold" className="uppercase">{`${indexT + 1}. ${term.title}`}</Typography>
              {term.content.map((content, indexC) => (
                <div key={`${indexT}-${indexC}`} className="flex flex-col gap-2">
                  <Typography>{`${content.text.includes('a)') || content.text.includes('b)') ? '' : `${indexT + 1}.${indexC + 1}.`} ${content.text}`}</Typography>
                  {content.subItems && content.subItems.map((subItem, indexS) => (
                    <Typography key={`${indexT}-${indexC}-${indexS}`}>{`${subItem.text.includes('a)') || subItem.text.includes('b)') ? '' : `${indexT + 1}.${indexC + 1}.${indexS + 1}.`} ${subItem.text}`}</Typography>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
        <Button variant="contained" className="w-fit px-24 mx-auto cursor-pointer" onClick={() => navigate('/indicacao')}>
          Voltar
        </Button>
      </div>
    </div>
  )
}

export default MGMTermsPage;